import React from 'react';
import Navigation from '../components/Navigation';
import AskQuestion from '../components/AskQuestion';
import './MVP.css';

function MVP() {
  return (
    <div>
      <Navigation hideLogin={true} />
      <div className="mvp-container">
        <AskQuestion />
      </div>
    </div>
  );
}

export default MVP; 